import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { PProFetch } from '../ajax';

export default function PasswordChange() {
	const [fpInfo, setFpInfo] = useState({
		root: {
			submitCommand: null,
			REDIRECT: null,
			EMAL: null,
			OLD_PASSWORD: null,
			NEW_PASSWORD: null,
			CONFIRM: null,
			style: null,
			MESSAGE: null,
			CURRENT_PWD_LABEL: null,
			WBID: null,
			CHILD: null,
			FORCE_CHANGE: null,
			hidden: null,
			requirements: null,
		},
		rowData: {}
	});
	
	const [emailField, setEmailField] = useState("");
	const [oldPasswordField, setOldPasswordField] = useState("");
	const [newPasswordField, setNewPasswordField] = useState("");
	const [confirmField, setConfirmField] = useState("");
	const [loading, setLoading] = useState(true);
	let message = null;
	if (fpInfo.root.MESSAGE) {
		message = <div className={fpInfo.root.style?.value}>{fpInfo.root.MESSAGE?.value}</div>
	}

	const updateStateFromAjax = (json) => {
		setFpInfo({...json});
		setEmailField(json.root.EMAL.value);
		setLoading(false);
	}

	useEffect(() => {
		setLoading(true);
		PProFetch("command=changePassword")
		.then(response => {
			return response.json();
		})
		.then(json => {
			updateStateFromAjax(json);
		});
	}, []);


	const submitFormHandler = (_) => {
		setLoading(true);
		const formData = new URLSearchParams();
		formData.append("command", fpInfo.root.submitCommand);
		formData.append("EMAL", emailField);
		formData.append("OLD_PASSWORD", oldPasswordField);
		formData.append("NEW_PASSWORD", newPasswordField);
		formData.append("CONFIRM", confirmField);
		formData.append("FORCE_CHANGE", fpInfo.root.FORCE_CHANGE.value);
		PProFetch(fpInfo.root.postUrl, {
			method: "POST",
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: formData
		}).then(response => {
			return response.json();
		}).then(json => {
			if (json.root.REDIRECT?.value) {
				window.location = json.root.REDIRECT.value;
			} else {
				updateStateFromAjax(json);
			}
		}).catch(err => {
			console.error(err);
		});
	}
	const changeEmailHandler = (event) => {
		setEmailField(event.target.value);
	}
	const changeOldPasswordHandler = (event) => {
		setOldPasswordField(event.target.value);
	}
	const changeNewPasswordHandler = (event) => {
		setNewPasswordField(event.target.value);
	}
	const changeConfirmPasswordHandler = (event) => {
		setConfirmField(event.target.value);
	}

	const isForceChange = () => {
		return fpInfo.root.FORCE_CHANGE?.value === "Y";
	}

	return (
		<React.Fragment>
			<div className="accountPageHeader">
				<h3 className="blocktext font-size--l text-color--gray5 mb-4">
					{isForceChange() ?
						'Update Password' :
						'Update Email Address or Password'}
				</h3>
			</div>

			{message}

			<span className={fpInfo.root.hidden ? fpInfo.root.hidden.value : "hidden"}><div className="alert alert-warning">Please change your password before continuing.</div></span>

			<p>{fpInfo.root.requirements?.value}</p>

			<p>Please enter your current password, your new password, and confirm your
			new password by entering it again.&nbsp;
			{isForceChange() ?
				"" :
				"If you would like to update your email address only, you may leave the new and confirm password fields empty."}
			</p>

			<div className="bg-light px-3 py-4 p-sm-4 p-md-md1">
				<div className="row">
					<div className="col-12 col-lg-6">
						<div className="form-group required">
							<label htmlFor="EMAL">Email:</label>
							{ loading ? <Skeleton height="45px"/> : <input type="text" size="50" value={emailField} onChange={changeEmailHandler} maxLength="400" name="EMAL"  id="EMAL" autoComplete="off" /> }
						</div>
					</div>
					<div className="w-100 d-sm-none d-md-block d-lg-none"></div>
					<div className="col-12 col-lg-6">
						<div className="form-group required">
							<label htmlFor="OLD_PASSWORD">Current Password:</label>
							{ loading ? <Skeleton height="45px"/> : <input type="password" size="12" value={oldPasswordField} onChange={changeOldPasswordHandler} maxLength="12" name="OLD_PASSWORD"  id="OLD_PASSWORD" autoComplete="off" /> }
						</div>
					</div>
					<div className="w-100 d-xl-none"></div>
					<div className="col-12 col-lg-6">
						<div className="form-group required">
							<label htmlFor="NEW_PASSWORD">New Password:</label>
							{ loading ? <Skeleton height="45px"/> : <input type="password" size="12" value={newPasswordField} onChange={changeNewPasswordHandler} maxLength="12" name="NEW_PASSWORD"  id="NEW_PASSWORD" autoComplete="new-password" /> }
						</div>
					</div>
					<div className="w-100 d-sm-none d-md-block d-lg-none"></div>
					<div className="col-12 col-lg-6">
						<div className="form-group required">
							<label htmlFor="CONFIRM">Confirm Password:</label>
							{ loading ? <Skeleton height="45px"/> : <input type="password" size="12" value={confirmField} onChange={changeConfirmPasswordHandler} maxLength="12" name="CONFIRM"  id="CONFIRM" autoComplete="new-password" /> }
						</div>
					</div>
				</div>
				<div className="d-flex flex-wrap justify-content-end align-items-center mt-3">
					<div className="text-color--gray4 my-2">
						<span className="text-color--red">*</span>
						<em>Indicates a required field.</em>
					</div>
					{ loading ? <Skeleton height="45px"/> : <input type="submit" className="button ms-3 submit" value="Submit" onClick={submitFormHandler} /> }
				</div>
			</div>
		</React.Fragment>
	)
}